import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const SQDropdown = ({ row }) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const handleToggle = () => {
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 10,
                left: rect.right - 120,
            });
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                buttonRef.current &&
                menuRef.current &&
                !buttonRef.current.contains(event.target) &&
                !menuRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        const handleScroll = () => {
            setIsOpen(false);
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            window.addEventListener("scroll", handleScroll, true);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <div className="dropdown">
            <button
                type="button"
                className="link dropdown-toggle"
                aria-expanded="false"
                onClick={handleToggle}
                ref={buttonRef}
                title="Purchase orders"
            >
                <em class="icon ni ni-info"></em>
            </button>
            {isOpen &&
                createPortal(
                    <ul
                        className="position-fixed dropdown-menu dropdown-menu-end dropdown-menu-xs show px-2 py-1"
                        style={{
                            maxHeight: "200px",
                            top: `${position.top}px`,
                            left: `${position.left}px`,
                        }}
                        ref={menuRef}
                    >
                        <li>actual stock quantity: {row?.stock_quantity}</li>
                        <li>ordered quantity: {row?.order_quantity}</li>
                    </ul>,
                    document.body
                )}
        </div>
    );
};

export default SQDropdown;
